import Vue from 'vue'
import Vuex from 'vuex'

//고객사 관리
import client from './client'
//업무 관리
import project from './project'
//분석 관리
import analysis from './analysis'
//사용자 관리
import user from './user'
//대시보드 관리
import dashboard from './dashboard'
//정산 관리
import settlement from './settlement'
//부서 옵션
import department from './department'

Vue.use(Vuex)

const store = new Vuex.Store({
	namespaced: true,
	modules: {
		client,
		project,
		analysis,
		user,
		dashboard,
		settlement,
		department
	}
})

export default store
